<template>
  <!-- Modal Component Search Rep-->
  <b-modal
    id="SearchRep"
    ref="searchRepModal"
    centered
    hide-header-close
    no-stacking
    no-close-on-esc
    no-close-on-backdrop
    no-enforce-focus
    ok-only
    ok-title="Buscar"
    title="Estimada Representante"
    visible
    @ok="handleOk"
    @shown="focusMyElement"
  >
    <p>
      Estamos en un proceso de actualización de datos para brindarte un mejor
      servicio, Por favor Ingrese los datos solicitados:
    </p>
    <b-form inline @submit.stop.prevent="handleOk">
      <label class="col-sm-4 col-form-label" for="repContract"
        >N° Contrato</label
      >
      <b-form-input
        id="repContract"
        ref="focusThis"
        v-model="repContract"
        v-validate="'required|numeric'"
        :state="validateState('repContract')"
        aria-describedby="inputLiveFeedback"
        data-vv-as="N° Contrato"
        maxlength="11"
        name="repContract"
        placeholder="Ejemplo: 01021234567"
        type="text"
        number
      />
      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors.first("repContract") }}
      </b-form-invalid-feedback>
    </b-form>

    <div slot="modal-footer" class="w-100">
      <b-button
        class="float-right"
        size="sm"
        variant="success"
        @click="handleOk"
      >
        Buscar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// import { mapFields } from 'vee-validate';

export default {
  name: "SearchRep",
  data() {
    return {
      repContract: "",
      errorNro: 0,
      errorOccurred: false
    };
  },
  computed: {
    ...mapState(["contractNumber", "repData"])
  },
  methods: {
    ...mapMutations(["SET_CONTRACTNUMBER", "SET_REPDATA", "SET_WASUPDATED"]),
    validateState: function(ref) {
      if (
        this.fields[ref] &&
        (this.fields[ref].dirty || this.fields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    // preventoToHide: function() {
    //   this.$root.$emit("bv::show::SearchRep", "SearchRep");
    // },
    handleOk: function(evt) {
      evt.preventDefault();

      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.repContract !== "") {
            this.handleSubmit();
          } else {
            alert("Por favor corrija los datos proporcionados");
          }
        }
      });
    },
    handleSubmit: function() {
      this.searchRep(this.repContract);
    },
    focusMyElement() {
      this.$refs.focusThis.focus();
    },
    searchRep: function(contractNumber) {
      contractNumber = ("00000000000" + contractNumber).slice(-11);
      //var urlApi = "/rep/" + contractNumber;
      var urlApi = "/rep/" + contractNumber;
      this.errorNro = 0;

      this.axios
        .get(urlApi)
        .then(response => {
          if (response.data.wasUpdated) {
            //console.log(response.data);
            this.$toastr(
              "info",
              `N° de Contrato <strong>${contractNumber}</strong> de<br/>
               <strong>
               ${response.data.firstName} ${response.data.lastName}
               </strong><br/>
               ya fué actualizado...`
            );

            this.SET_WASUPDATED(true);

            this.$cookie.set(
              "AvonRep",
              { updated: true, when: Date() },
              { expires: 30, domain: "localhost" }
            );

            this.$refs.searchRepModal.hide();
            Promise.resolve();
          } else {
            this.errorOccurred = false;

            this.SET_CONTRACTNUMBER(this.repContract);
            this.SET_REPDATA(response.data);
            this.repContract = "";

            this.$refs.searchRepModal.hide();
            this.$root.$emit("bv::show::modal", "updateRepModal");
          }
        })
        .catch(error => {
          this.errorNro = error.response.status;
          //console.log(error);
          if (this.errorNro === 404) {
            this.$toastr(
              "error",
              "N° de Contrato ingresado No Existe o es Invalido...",
              "Error"
            );
          } else if (this.errorNro === 408 || this.errorNro >= 500) {
            this.$toastr(
              "error",
              "Ha ocurrido un error de comunicación...",
              "Error"
            );
          } else if (this.errorNro >= 503) {
            this.$toastr(
              "error",
              "Ha ocurrido un error Servicio No Disponible...",
              "Error"
            );
          } else {
            this.$toastr("error", "Ha ocurrido un error...", "Error");
          }
          Promise.resolve();
        });
    }
  }
};
</script>

<style></style>
